import { Component, EventEmitter, forwardRef, Host, Input, OnInit, Optional, Output, SkipSelf } from '@angular/core';
import { ControlContainer, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { conformToMask } from 'angular2-text-mask';
import * as moment from 'moment';
import { inputMgsErrs } from 'src/app/validators/message-validation';
import { FormComponentControl } from '../form-component-control';

@Component({
  selector: 'app-input-datepicker',
  templateUrl: './input-datepicker.component.html',
  styleUrls: ['./input-datepicker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDatepickerComponent),
      multi: true
    }
  ]
})
export class InputDatepickerComponent extends FormComponentControl implements OnInit {
  @Input() isDisabled: boolean;
  @Input() isPB: boolean;
  language: string;
  private _focus = true;
  errors = inputMgsErrs.datePickerText;
  dateEdit: any;
  public mask = [/[0-9]/,/\d/,'/', /\d/, /\d/,'/', /\d/, /\d/, /\d/, /\d/];

  constructor(
    @Optional()
    @Host()
    @SkipSelf()
    private cc: ControlContainer,
    private dateAdapter: DateAdapter<Date>,
    private translateForm: TranslateService,
  ) {
    super(cc);
  }

  ngOnInit() {
    this.dateEdit = null;
    this.language = this.translateForm.currentLang;
    if (navigator.appVersion.toString().indexOf('.NET') > 0) {
      this.browserIE = true;
    }
    this.dateConfig();
    this.checkInitialControl();
  }

  dateConfig() {
    if (this.language == 'th') {
      this.dateAdapter.setLocale('th-TH');
    }
  }

  onBlur() {
    super.onBlur();
  }

  onFocus() {
    super.onFocus();
  }

  dateCalendar(val) {
    if (val.value != null && val.value != '') {
      let datePicker = new Date(val.value);
      if (datePicker !== this.innerValue) {
        super.setValue(datePicker);
      }
    } else {
      if (val.value !== this.innerValue) {
        super.setValue(val.value);
      }
    }

  }


}
